// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.antraege-page {
  padding-bottom: 40px;
}

/* Filter-Leiste */
.antraege-filter {
  display: flex;
  gap: 12px;
  margin: 16px 0;
  flex-wrap: wrap;
}

.antraege-filter .dropdown-wrapper {
  flex: 1 1;
  min-width: 140px;
}

.antraege-filter .dropdown-wrapper select {
  background-color: var(--mittelgruen);
  border-radius: 10px;
  padding: 10px 36px 10px 12px;
  color: var(--dunkelgruen);
  font-size: 1em;
  width: 100%;
}

.antraege-loading,
.antraege-leer {
  text-align: center;
  color: var(--dunkelgruen);
  margin-top: 24px;
  font-size: 1.1em;
}

.antraege-error {
  background-color: var(--blutorange);
  color: white;
  border-radius: 10px;
  padding: 10px 16px;
  margin-bottom: 12px;
}

/* Antragskarte */
.antraege-liste {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 8px;
}

.antrag-card {
  background-color: var(--hellgruen);
  border-radius: 12px;
  padding: 16px;
  border-left: 5px solid var(--dunkelgruen);
  position: relative;
  transition: box-shadow 0.2s ease;
}

.antrag-card:hover {
  box-shadow: 0 2px 12px rgba(100, 130, 2, 0.18);
}

.antrag-card.status-eingegangen {
  border-left-color: var(--gelb);
}

.antrag-card.status-in-bearbeitung {
  border-left-color: var(--hellblau);
}

.antrag-card.status-erledigt {
  border-left-color: var(--dunkelgruen);
  opacity: 0.85;
}

.antrag-card.duplikat {
  border: 2px dashed var(--blutorange);
  border-left-width: 5px;
  border-left-style: solid;
}

/* Duplikat-Badge */
.duplikat-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: var(--blutorange);
  color: white;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 0.85em;
  margin-bottom: 10px;
  width: fit-content;
}

.duplikat-badge .material-symbols-outlined {
  font-size: 1em;
}

/* Header mit Name und Status */
.antrag-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.antrag-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.antrag-name {
  font-size: 1.15em;
  color: var(--dunkelgruen);
  font-weight: bold;
}

.antrag-bereich {
  font-size: 0.88em;
  color: var(--placeholder);
}

/* Status-Badge */
.status-badge {
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 0.88em;
  white-space: nowrap;
  font-family: 'Circular', sans-serif;
}

.status-badge.status-eingegangen {
  background-color: var(--gelb);
  color: var(--dunkelgruen);
}

.status-badge.status-in-bearbeitung {
  background-color: var(--hellblau);
  color: white;
}

.status-badge.status-erledigt {
  background-color: var(--dunkelgruen);
  color: white;
}

.status-icon {
  font-size: 1em;
}

/* Antragstext */
.antrag-text {
  color: var(--dunkelgruen);
  font-family: 'Circular', sans-serif;
  font-size: 0.95em;
  line-height: 1.5;
  margin: 8px 0;
  text-align: left;
}

/* Footer: Ausschuss + Datum */
.antrag-footer {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
}

.antrag-ausschuss,
.antrag-datum {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.85em;
  color: var(--mittelblau);
  font-family: 'Circular', sans-serif;
}

.antrag-ausschuss .material-symbols-outlined,
.antrag-datum .material-symbols-outlined {
  font-size: 1em;
}

/* Kommentar */
.antrag-kommentar {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  background-color: rgba(100, 130, 2, 0.1);
  border-radius: 8px;
  padding: 8px 12px;
  margin-top: 10px;
  font-size: 0.9em;
  color: var(--dunkelgruen);
  font-family: 'Circular', sans-serif;
  text-align: left;
}

.antrag-kommentar .material-symbols-outlined {
  font-size: 1em;
  flex-shrink: 0;
  margin-top: 1px;
}

/* Aktions-Buttons (Parlament) */
.antrag-actions {
  display: flex;
  gap: 10px;
  margin-top: 12px;
}

.antrag-actions button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  font-size: 0.9em;
  margin-top: 0;
  width: auto;
}

.antrag-actions .material-symbols-outlined {
  font-size: 1em;
}

.btn-edit {
  background-color: var(--hellblau);
}

.btn-delete {
  background-color: var(--blutorange);
}

/* Bearbeitungsformular */
.antrag-edit-form {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid rgba(100, 130, 2, 0.2);
}

.antrag-edit-form .freitext-label {
  color: var(--dunkelgruen);
  margin-bottom: 10px;
  display: block;
}

.antrag-edit-form .freitext-input {
  width: 100%;
  resize: vertical;
}

.antrag-edit-buttons {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.antrag-edit-buttons button {
  width: auto;
  padding: 10px 20px;
  margin-top: 0;
  font-size: 1em;
}
`, "",{"version":3,"sources":["webpack://./src/components/parlament/antraege/Antraege.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB;EACzB,cAAc;EACd,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;;EAEE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB","sourcesContent":[".antraege-page {\n  padding-bottom: 40px;\n}\n\n/* Filter-Leiste */\n.antraege-filter {\n  display: flex;\n  gap: 12px;\n  margin: 16px 0;\n  flex-wrap: wrap;\n}\n\n.antraege-filter .dropdown-wrapper {\n  flex: 1;\n  min-width: 140px;\n}\n\n.antraege-filter .dropdown-wrapper select {\n  background-color: var(--mittelgruen);\n  border-radius: 10px;\n  padding: 10px 36px 10px 12px;\n  color: var(--dunkelgruen);\n  font-size: 1em;\n  width: 100%;\n}\n\n.antraege-loading,\n.antraege-leer {\n  text-align: center;\n  color: var(--dunkelgruen);\n  margin-top: 24px;\n  font-size: 1.1em;\n}\n\n.antraege-error {\n  background-color: var(--blutorange);\n  color: white;\n  border-radius: 10px;\n  padding: 10px 16px;\n  margin-bottom: 12px;\n}\n\n/* Antragskarte */\n.antraege-liste {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  margin-top: 8px;\n}\n\n.antrag-card {\n  background-color: var(--hellgruen);\n  border-radius: 12px;\n  padding: 16px;\n  border-left: 5px solid var(--dunkelgruen);\n  position: relative;\n  transition: box-shadow 0.2s ease;\n}\n\n.antrag-card:hover {\n  box-shadow: 0 2px 12px rgba(100, 130, 2, 0.18);\n}\n\n.antrag-card.status-eingegangen {\n  border-left-color: var(--gelb);\n}\n\n.antrag-card.status-in-bearbeitung {\n  border-left-color: var(--hellblau);\n}\n\n.antrag-card.status-erledigt {\n  border-left-color: var(--dunkelgruen);\n  opacity: 0.85;\n}\n\n.antrag-card.duplikat {\n  border: 2px dashed var(--blutorange);\n  border-left-width: 5px;\n  border-left-style: solid;\n}\n\n/* Duplikat-Badge */\n.duplikat-badge {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background-color: var(--blutorange);\n  color: white;\n  border-radius: 6px;\n  padding: 4px 10px;\n  font-size: 0.85em;\n  margin-bottom: 10px;\n  width: fit-content;\n}\n\n.duplikat-badge .material-symbols-outlined {\n  font-size: 1em;\n}\n\n/* Header mit Name und Status */\n.antrag-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.antrag-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.antrag-name {\n  font-size: 1.15em;\n  color: var(--dunkelgruen);\n  font-weight: bold;\n}\n\n.antrag-bereich {\n  font-size: 0.88em;\n  color: var(--placeholder);\n}\n\n/* Status-Badge */\n.status-badge {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  border-radius: 20px;\n  padding: 4px 12px;\n  font-size: 0.88em;\n  white-space: nowrap;\n  font-family: 'Circular', sans-serif;\n}\n\n.status-badge.status-eingegangen {\n  background-color: var(--gelb);\n  color: var(--dunkelgruen);\n}\n\n.status-badge.status-in-bearbeitung {\n  background-color: var(--hellblau);\n  color: white;\n}\n\n.status-badge.status-erledigt {\n  background-color: var(--dunkelgruen);\n  color: white;\n}\n\n.status-icon {\n  font-size: 1em;\n}\n\n/* Antragstext */\n.antrag-text {\n  color: var(--dunkelgruen);\n  font-family: 'Circular', sans-serif;\n  font-size: 0.95em;\n  line-height: 1.5;\n  margin: 8px 0;\n  text-align: left;\n}\n\n/* Footer: Ausschuss + Datum */\n.antrag-footer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 8px;\n}\n\n.antrag-ausschuss,\n.antrag-datum {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.85em;\n  color: var(--mittelblau);\n  font-family: 'Circular', sans-serif;\n}\n\n.antrag-ausschuss .material-symbols-outlined,\n.antrag-datum .material-symbols-outlined {\n  font-size: 1em;\n}\n\n/* Kommentar */\n.antrag-kommentar {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  background-color: rgba(100, 130, 2, 0.1);\n  border-radius: 8px;\n  padding: 8px 12px;\n  margin-top: 10px;\n  font-size: 0.9em;\n  color: var(--dunkelgruen);\n  font-family: 'Circular', sans-serif;\n  text-align: left;\n}\n\n.antrag-kommentar .material-symbols-outlined {\n  font-size: 1em;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n/* Aktions-Buttons (Parlament) */\n.antrag-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.antrag-actions button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-size: 0.9em;\n  margin-top: 0;\n  width: auto;\n}\n\n.antrag-actions .material-symbols-outlined {\n  font-size: 1em;\n}\n\n.btn-edit {\n  background-color: var(--hellblau);\n}\n\n.btn-delete {\n  background-color: var(--blutorange);\n}\n\n/* Bearbeitungsformular */\n.antrag-edit-form {\n  margin-top: 14px;\n  padding-top: 14px;\n  border-top: 1px solid rgba(100, 130, 2, 0.2);\n}\n\n.antrag-edit-form .freitext-label {\n  color: var(--dunkelgruen);\n  margin-bottom: 10px;\n  display: block;\n}\n\n.antrag-edit-form .freitext-input {\n  width: 100%;\n  resize: vertical;\n}\n\n.antrag-edit-buttons {\n  display: flex;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.antrag-edit-buttons button {\n  width: auto;\n  padding: 10px 20px;\n  margin-top: 0;\n  font-size: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
